import LogoImage from '../../assets/images/logo.webp';
import { useTheme, useMediaQuery } from '@mui/material';

const Logo = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <img
      src={LogoImage}
      alt="logo"
      style={{
        maxWidth: isMobile ? 160 : 200,
        height: 'auto',
      }}
    />
  );
};

export default Logo;
